import {
    POST,
    GET,
    Delete
} from "../util";

const inspectionUrl = "api/account-inspection";
const operationUrl = "api/account-operation";

const url = {
    inspection: {
        listAccounts: `${inspectionUrl}/list?excludeMainAccount=:excludeMainAccount`,
        accountInfo: `${inspectionUrl}/:accountId`,
    },

    operation: {
        addAccount: `${operationUrl}/add`,
        editAccount: `${operationUrl}/:accountId/update`,
        enableAccount: `${operationUrl}/:accountId/enable`,
        disableAccount: `${operationUrl}/:accountId/disable`,
        deleteAccount: `${operationUrl}/:accountId/delete`,
    }
};

const accountManagementApi = {
    inspection: {
        listAccounts: (params = {}, excludeMainAccount = false) => {
            return POST(url.inspection.listAccounts.replace(":excludeMainAccount", excludeMainAccount), params);
        },
        getAccountInfo: (id) => {
            return GET(url.inspection.accountInfo.replace(":accountId", id));
        }
    },
    operation: {
        addAccount: (data) => {
            return POST(url.operation.addAccount, data);
        },
        editAccount: (id, data) => {
            return POST(url.operation.editAccount.replace(":accountId", id), data);
        },
        enableAccount: (id) => {
            return POST(url.operation.enableAccount.replace(":accountId", id));
        },
        disableAccount: (id) => {
            return POST(url.operation.disableAccount.replace(":accountId", id));
        },
        deleteAccount: (id) => {
            return Delete(url.operation.deleteAccount.replace(":accountId", id));
        }
    }
};
export {
    accountManagementApi
};